export default __webpack_public_path__ + "static/media/Heirlooms.c88aee4c.pdf";